import React from 'react';
import styled from 'styled-components';
import { MapPrint } from '../../../maps';

const Container = styled.div`
  padding-bottom: 8px;
  width: ${({ halfWidth }) => (halfWidth ? '50%' : '100%')};
  display: inline-block;
  padding-right: ${({ halfWidth }) => (halfWidth ? '2px' : '0')};
  box-sizing: border-box;
`;

const MapWrapper = styled.div`
  width: 100%;
  min-height: 700px;
  height: 100%;
`;

/* eslint-disable react/style-prop-object */
export const PrintMap = () => (
  <Container>
    <MapWrapper>
      <MapPrint
        id="PRINT_MAP"
      />
    </MapWrapper>
  </Container>
);
